import { render, staticRenderFns } from "./WilkaLockDialog.vue?vue&type=template&id=77e1784b&"
import script from "./WilkaLockDialog.vue?vue&type=script&lang=js&"
export * from "./WilkaLockDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports